/**
 * Wizard 2 Klaviyo Integration
 * Extends KlaviyoEventManager to use wizard-4 backend endpoints
 */
(function() {
  if (typeof KlaviyoEventManager === 'undefined') return;

  class KlaviyoEventManagerWizard extends KlaviyoEventManager {
    getApiPrefix() {
      return 'wizard-4';
    }

    getStorageKey(customerEmail) {
      return `klaviyo_pending_event_wizard_${customerEmail}`;
    }

    async startTimer(customerEmail) {
      this.cancelPendingEvent();
      const pendingEvent = this.loadPendingEvent(customerEmail);
      if (!pendingEvent) return;
      this.rememberQuizLocale(pendingEvent);
      this.savePendingEvent(customerEmail, pendingEvent);

      let remainingTime = this.timerDelay;
      if (pendingEvent.createdAt) {
        const elapsed = Date.now() - pendingEvent.createdAt;
        remainingTime = Math.max(0, this.timerDelay - elapsed);
      }

      if (remainingTime <= 0) {
        this.sendKlaviyoEvent(customerEmail);
        return;
      }

      try {
        const properties = this.formatEventProperties(pendingEvent.pets, pendingEvent.cartItems);
        const delayMinutes = Math.ceil(remainingTime / 60000);
        const res = await fetch(`${this.backendApiUrl}/api/wizard/schedule-quiz-event`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: pendingEvent.eventType,
            profile: pendingEvent.profile,
            properties,
            delayMinutes,
            journeyId: window.BzWizard.id()
          })
        });
        const data = await res.json().catch(() => ({}));
        if (data.ok && data.key) {
          pendingEvent.scheduleKey = data.key;
          this.savePendingEvent(customerEmail, pendingEvent);
        } else {
          this.fallbackToLocalTimer(customerEmail, remainingTime);
        }
      } catch (e) {
        this.fallbackToLocalTimer(customerEmail, remainingTime);
      }
    }

    async cancelScheduledEvent(key) {
      if (!key || !this.backendApiUrl) return;
      try {
        await fetch(`${this.backendApiUrl}/api/wizard/cancel-quiz-event`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ key })
        });
      } catch (e) {}
    }

    async sendKlaviyoEvent(customerEmail) {
      const pendingEvent = this.loadPendingEvent(customerEmail);
      if (!pendingEvent) return;
      this.rememberQuizLocale(pendingEvent);

      try {
        const properties = this.formatEventProperties(pendingEvent.pets, pendingEvent.cartItems);
        await this.cancelScheduledEvent(pendingEvent.scheduleKey);

        const response = await fetch(`${this.backendApiUrl}/api/wizard/send-quiz-event-now`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: pendingEvent.eventType,
            profile: pendingEvent.profile,
            properties,
            journeyId: window.BzWizard.id()
          })
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `HTTP ${response.status}`);
        }

        this.clearPendingEvent(customerEmail);
        this.pendingEvent = null;
      } catch (error) {
        console.error('Klaviyo event send failed:', error);
      }
    }
  }

  window.KlaviyoEventManagerWizard = KlaviyoEventManagerWizard;
})();
